import request from '../../../../util/request';
import Cookies from 'js-cookie';
export function uploadImgRequest(file, fileName, callback) {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', fileName);
    return request(
        '/upload',
        {
            method: 'POST',
            body: formData,
        },
        callback
    );
}

export function createBotRequest(
    space_id,
    name,
    description,
    icon_file_id,
    icon_url,
    prompt,
    prologue,
    suggested_questions,
    callback
) {
    return request(
        '/cBot',
        {
            method: 'POST',
            body: {
                "userToken":Cookies.get("userToken"),
                "userName":Cookies.get("name"),
                space_id,
                name,
                description,
                icon_file_id,
                icon_url,
                prompt,
                prologue,
                suggested_questions,
            },
        },
        callback
    );
}

export function updateBotRequest(
    bot_id,
    name,
    description,
    icon_file_id,
    icon_url,
    prompt,
    prologue,
    suggested_questions,
    callback
) {
    let bodyDic = {
                "userToken":Cookies.get("userToken"),
                bot_id,
                name,
                description,
                icon_file_id,
                icon_url,
                "prompt_info": {
                    "prompt": prompt
                },
                "onboarding_info":{
                    "prologue": prologue,
                    "suggested_questions": suggested_questions,
                }
            }
    if(icon_file_id==""){
        delete bodyDic.icon_file_id
        delete bodyDic.icon_url
    }else{
        bodyDic.icon_file_id = icon_file_id
        bodyDic.icon_url = icon_url
    }
    return request(
        '/uBot',
        {
            method: 'POST',
            body: bodyDic,
        },
        callback
    );
}
export function publishBotRequest(
    bot_id,
    name,
    description,
    icon_file_id,
    icon_url,
    prompt,
    prologue,
    suggested_questions,
    callback
) {
    let bodyDic = {
                "userToken":Cookies.get("userToken"),
                bot_id,
                name,
                description,
                icon_file_id,
                icon_url,
                "prompt_info": {
                    "prompt": prompt
                },
                "onboarding_info":{
                    "prologue": prologue,
                    "suggested_questions": suggested_questions,
                }
            }
    if(icon_file_id==""){
        delete bodyDic.icon_file_id
        delete bodyDic.icon_url
    }else{
        bodyDic.icon_file_id = icon_file_id
        bodyDic.icon_url = icon_url
    }
    return request(
        '/publishBot',
        {
            method: 'POST',
            body: bodyDic,
        },
        callback
    );
}
export function getBotRequest(bot_id, callback) {
    return request(
        '/getBot',
        {
            method: 'POST',
            body: {
                bot_id,
            },
        },
        callback
    );
}

